// client/src/hooks/useCurrentUser.js
// Decodes the JWT in localStorage to read access-tier claims (isManagingBroker, staffRole, isTeamLead, agentId)
// without waiting on a network round trip.
export const getCurrentUser = () => {
    const token = localStorage.getItem('jwtToken');
    if (!token) return null;
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};

export const canManageStaff = (user) => !!(user?.isManagingBroker || user?.staffRole === 'Office Manager');

// Whose agent/employee documents this login may open: their own, the managing broker's
// and office manager's, and an examiner's (same rule as GET /api/agents/:id/documents and
// /api/employees/:id/documents). Used to hide the panel instead of showing a 403.
export const canSeePersonFile = (user, { agentId, employeeId } = {}) => {
    if (!user) return false;
    if (user.isManagingBroker || user.staffRole === 'Office Manager' || user.role === 'examiner') return true;
    if (agentId != null && Number(user.agentId) === Number(agentId)) return true;
    if (employeeId != null && Number(user.employeeId) === Number(employeeId)) return true;
    return false;
};
